import 'whatwg-fetch';
import { Component } from '../../node_modules/react';
import Slider from '../../node_modules/react-slick';
import GetResults from './GetResults';
import GetVideo from './GetVideo';
import arrowLeft from '../assets/arrow-left.svg';
import arrowRight from '../assets/arrow-right.svg';

class Blog extends Component { 
    
    constructor(props) {
        super(props);
        this.state = {
            feed: "https://" + window.location.host + "/" + 'wp-json/wp/v2/posts?per_page=100&order=desc&_fields=link,title,featured_media,categories,_links,_embedded&_embed',
            cats: props.cats, 
            search: null,
            video: props.video,
            activeCats: [],
            activeCatsName: [],
            isLoading: true,
            posts: []
        };
        this.getFeed = this.getFeed.bind(this);
    }

    componentDidMount() {
        this.getFeed( this.state.feed );
    }

    getFeed = () => {

        let totalPages = 0;
        let allResults = [];
        
        fetch(this.state.feed, {
            method: 'GET',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json' 
            },
        }).then( response => {
            totalPages = response.headers.get('X-WP-TotalPages');
            // console.log('aaa', response);
            return response.json()
        })
        .then( async data => {
            console.log(data);
            this.setState({
                posts: this.state.posts.concat(data),
                isLoading: false
            });
            for (let i = 2; i <= totalPages ; i++){
                let feed_url = this.state.feed + '&page=' + i;
                fetch(feed_url, {
                        method: 'GET',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    })
                    .then( async response => {
                        // console.log('inside loop', totalPages, response);
                        return response.json()
                    })
                    .then( moreresults => {
                        // console.log('test', moreresults);
                        this.setState({
                            posts: this.state.posts.concat(moreresults),
                        });
                    }).catch((error) => {
                        console.error('catch error loop: ', error, response);
                    });
            }
        }) 
        .catch((response, error) => {
            console.error('catch error first: ', response);
        })
        
    }

    handleSearchChange = (event) => {
        let keyword = event.target.value;
        this.setState({
            search: keyword
        })
    }

    handleCatChange = (event, id, name) => {
        event.preventDefault();
        
        if( !this.state.activeCats.includes(id)){
            this.setState({
                activeCats: [...this.state.activeCats, id],
                activeCatsName: [...this.state.activeCatsName, name]
            })
        } else {
            this.setState({
                activeCats: this.state.activeCats.filter(function(s) {
                    return s != id
                }),
                activeCatsName: this.state.activeCatsName.filter(function(s) {
                    return s != name
                })
            })
        }
    }

    handleRemoveCat = (e, name, id) => {
        this.setState({
            activeCats: this.state.activeCats.filter(function(s) {
                return s != id
            }),
            activeCatsName: this.state.activeCatsName.filter(function(s) {
                return s != name
            })
        })
    }

    reset = (event) => {
        event.preventDefault();
        this.setState({
            search: '',
            activeCats: [],
            activeCatsName: []
        })
    }

    renderGrid = () => {
        if (this.state.posts) {
            const posts = Object.values(this.state.posts);
            const search = this.state.search;
            const cats = this.state.cats;
            const activeCats = this.state.activeCats;
            return ( <GetResults cats={cats} activeCats={activeCats} search={ search } posts={ posts } /> );
        }
    }
    
    renderLoadingScreen = () => {
        return (
            <div>
                <div dangerouslySetInnerHTML={ {__html: this.props.loading } } /> 
            </div>
        );
    }

    renderActiveCats = () => {
        if(this.state.activeCatsName.length > 0) {
            return ( 
                this.state.activeCatsName.map( (c, idx) => {
                    return(<span className={`blog-grid__search-cats`} onClick={(e) => this.handleRemoveCat(e, c, this.state.activeCats[idx])}>{c} <span>x</span></span>)
                })
             );
        }
    }

    renderVideo = () => {
        let video = this.state.video;
        if (video.video_url) {
            return ( <GetVideo video={ video } /> );
        }
    }

    render(){
        const sliderSettings = {
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            }, {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                }
            }, {
                breakpoint: 450,
                settings: {
                    slidesToShow: 2,
                }
            }]
        };
        const isIE = /*@cc_on!@*/false || !!document.documentMode;

        return(
            <>
                { this.renderVideo() }
                <div className={`blog-grid__search`}>
                    <div className={`blog-grid__search-title`}>
                        <p>Browse by category below:</p>
                        <p>{this.renderActiveCats()}</p>
                    </div>
                    <div className={`blog-grid__search-view`}>
                        <button onClick={(e)=>this.reset(e)}>View all</button>
                    </div>
                    <div className={`blog-grid__search-keyword`}>
                        <input placeholder={`Search by keywords`} name={`search`} type={`text`} onChange={(e)=>this.handleSearchChange(e)}  />
                    </div>
                </div>
                { this.state.cats && (
                    <div className={`blog-grid__cats`}>
                        <Slider {...sliderSettings}>
                        { this.state.cats && this.state.cats.map((cat, idx) => (
                            <div className={`blog-grid__cat ${this.state.activeCats.includes(cat.term_id) ? 'blog-grid__cat--active' : '' }`} onClick={(e) => this.handleCatChange(e, cat.term_id, cat.name)}>
                                <div className="blog-grid__cat-image" style={ isIE ? {
                                        backgroundImage: `url(${cat.image})`,
                                        backgroundPosition: `center`,
                                        backgroundSize: `cover`
                                    } : {}}>
                                    {cat.image && (
                                        <img style={isIE ? {
                                            opacity: 0,
                                        } : {}} src={ cat.image } alt={`Category Image for ${cat.name}`} />
                                    )}
                                </div>
                                <div className="blog-grid__cat-title">
                                    <h2>{cat.name}</h2>
                                </div>
                            </div>
                        ))}
                        </Slider>
                    </div>
                )}
                <div className={`blog-grid__divider`}></div>

                {this.state.isLoading ? this.renderLoadingScreen() : this.renderGrid()}
            </>     
        );
    }
}

function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        />
    );
}
  
function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        />
    );
}

export default Blog;